import { render } from "./FooterStyleSix.vue?vue&type=template&id=fda9f822"
import script from "./FooterStyleSix.vue?vue&type=script&lang=js"
export * from "./FooterStyleSix.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__